import React from 'react';

const MarketingService = () => (
  <div className="min-h-screen bg-white flex flex-col items-center justify-center px-0 py-0 animate__animated animate__fadeIn">
    {/* Hero Section */}
    <section className="w-full max-w-6xl mx-auto pt-24 pb-16 px-4 sm:px-8 flex flex-col-reverse lg:flex-row items-center gap-12">
      <div className="flex-1 text-center lg:text-left mt-8 lg:mt-0">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4 leading-tight">Turn Scrolls into Sales with a Magnetic Brand Presence</h1>
        <p className="text-lg sm:text-xl text-gray-700 mb-8 max-w-2xl mx-auto lg:mx-0">We don’t just set up your social media—we launch your brand with momentum.</p>
                        <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-10 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg mt-2">Start Your Brand Launch</a>
      </div>
      <div className="flex-1 flex justify-center">
        <img src="/images/SocialM.jpg" alt="Brand Discovery" className="w-64 h-64 lg:w-[28rem] lg:h-[28rem] object-cover rounded-2xl shadow-lg" />
      </div>
    </section>

    {/* The Problem Section */}
    <section className="w-full bg-[#f8fafc] border-y border-gray-100 py-12 px-4 sm:px-8">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">The Problem</h2>
        <p className="text-lg text-gray-700 mb-2">Most entrepreneurs struggle to turn great ideas into attention-grabbing brands. Social media often feels overwhelming or underwhelming—too much noise, not enough traction.</p>
      </div>
    </section>

    {/* Our Process Section */}
    <section className="w-full max-w-4xl mx-auto py-16 px-4 sm:px-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-10 text-center">Our Process</h2>
      <div className="flex flex-col gap-8">
        <div className="flex items-start gap-6">
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#e8f5e9] font-bold text-[#618A3D] text-xl mb-2">1</div>
            <div className="h-full w-px bg-[#e8f5e9] flex-1" />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-1">Brand Discovery</h3>
            <p className="text-gray-700 text-base">Understand your market, your audience, and your vibe.</p>
          </div>
        </div>
        <div className="flex items-start gap-6">
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#e8f5e9] font-bold text-[#618A3D] text-xl mb-2">2</div>
            <div className="h-full w-px bg-[#e8f5e9] flex-1" />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-1">Account Setup</h3>
            <p className="text-gray-700 text-base">We create and optimize 3 social accounts (Instagram, Facebook, Pinterest, or Twitter) based on your target audience.</p>
          </div>
        </div>
        <div className="flex items-start gap-6">
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#e8f5e9] font-bold text-[#618A3D] text-xl mb-2">3</div>
            <div className="h-full w-px bg-[#e8f5e9] flex-1" />
          </div>
          <div>
            <h3 className="font-bold text-lg mb-1">Content System</h3>
            <p className="text-gray-700 text-base">We build a simple mass-upload process, so you can stay consistent without the overwhelm.</p>
          </div>
        </div>
        <div className="flex items-start gap-6">
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#e8f5e9] font-bold text-[#618A3D] text-xl mb-2">4</div>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-1">Training + Handoff</h3>
            <p className="text-gray-700 text-base">You get platform guides and content strategy walkthroughs to keep your brand growing.</p>
          </div>
        </div>
      </div>
    </section>

    {/* What You Get Section */}
    <section className="w-full bg-[#f8fafc] border-y border-gray-100 py-12 px-4 sm:px-8">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 text-center">What You Get</h2>
        <ul className="space-y-4 text-lg text-gray-800 mb-4">
          <li className="flex items-center"><span className="text-green-600 text-2xl mr-3">✔</span> Fully Branded Social Profiles</li>
          <li className="flex items-center"><span className="text-green-600 text-2xl mr-3">✔</span> Strategic Account Setup</li>
          <li className="flex items-center"><span className="text-green-600 text-2xl mr-3">✔</span> Plug-and-Play Media Upload System</li>
          <li className="flex items-center"><span className="text-green-600 text-2xl mr-3">✔</span> Brand Style & Content Guide</li>
          <li className="flex items-center"><span className="text-green-600 text-2xl mr-3">✔</span> Personalized Growth Strategy</li>
        </ul>
      </div>
    </section>

    {/* Results Section */}
    <section className="w-full max-w-3xl mx-auto py-12 px-4 sm:px-8 text-center">
      <h2 className="text-3xl font-bold text-gray-900 mb-4">Let’s Build Your Brand Foundation</h2>
      <p className="text-lg text-gray-700 mb-2">Start showing up where your customers already are.</p>
      <p className="text-lg text-gray-700 mb-6">Build a trustworthy online identity that attracts, engages, and converts.</p>
                      <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-10 py-4 bg-[#618A3D] text-white font-bold rounded-lg shadow-lg hover:bg-[#75a64b] transition text-lg mt-2">Book Discovery Call</a>
    </section>
  </div>
);

export default MarketingService; 